(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["promo-code"] && !Shopify.designMode) return;
  try {
    (function () {
    function copier(texte) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(texte);
      }
      // Repli : contexte non sécurisé ou navigateur ancien.
      return new Promise(function (resoudre, rejeter) {
        var zone = document.createElement('textarea');
        zone.value = texte;
        zone.setAttribute('readonly', '');
        zone.style.cssText = 'position:fixed;top:-9999px;opacity:0';
        document.body.appendChild(zone);
        zone.select();
        try {
          document.execCommand('copy') ? resoudre() : rejeter();
        } catch (e) {
          rejeter(e);
        } finally {
          document.body.removeChild(zone);
        }
      });
    }

    document.addEventListener('click', function (evenement) {
      var bouton = evenement.target.closest('.promo-code');
      if (!bouton || bouton.classList.contains('is-copied')) return;

      copier(bouton.dataset.code).then(function () {
        var texte = bouton.querySelector('[data-ref="action-text"]');
        var annonce = bouton.querySelector('[data-ref="annonce"]');
        var avant = texte ? texte.textContent : '';

        bouton.classList.add('is-copied');
        if (texte) texte.textContent = bouton.dataset.copie;
        if (annonce) annonce.textContent = bouton.dataset.copie;

        setTimeout(function () {
          bouton.classList.remove('is-copied');
          if (texte) texte.textContent = avant;
          if (annonce) annonce.textContent = '';
        }, 2000);
      }).catch(function () {
        // Copie refusée : on ne casse rien, le code reste lisible et sélectionnable.
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
